import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Quiz, QuizDto, QuizValue, QuizValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getQuiz(id: string): Observable<Quiz> {
        return this.httpClient.get<QuizDto>(`quizzes/${id}`).pipe(map((dto) => new Quiz(dto)));
    }

    createQuiz(value: QuizValue): Observable<Quiz> {
        const dto = new QuizValueDto(value);
        return this.httpClient.post<QuizDto>('quizzes', dto).pipe(map((response) => new Quiz(response)));
    }

    updateQuiz(id: string, value: QuizValue): Observable<Quiz> {
        const dto = new QuizValueDto(value);
        return this.httpClient.patch<QuizDto>(`quizzes/${id}`, dto).pipe(map((response) => new Quiz(response)));
    }

    deleteQuiz(id: string): Observable<void> {
        return this.httpClient.delete<void>(`quizzes/${id}`);
    }
}
